import apiClient from 'config/axios.config';

const sosLogServices = {
  getSosLogs: async ({
    page = 1,
    limit = 10,
    status,
    userType,
    alertType,
    userId,
    startDate,
    endDate,
    sortBy = 'createdAt',
    sortOrder = 'desc',
  } = {}) => {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);
    if (status) params.append('status', status);
    if (userType) params.append('userType', userType);
    if (alertType) params.append('alertType', alertType);
    if (userId) params.append('userId', userId);
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);

    const response = await apiClient.get(`/admin/sos-logs?${params.toString()}`);
    return response.data;
  },

  getSosLogById: async (id) => {
    const response = await apiClient.get(`/admin/sos-logs/${id}`);
    return response.data;
  },

  updateSosLogStatus: async ({ sosLogId, status }) => {
    const response = await apiClient.patch(`/admin/sos-logs/${sosLogId}/status`, {
      status,
    });
    return response.data;
  },

  exportSOSLogs: async ({
  status,
  userType,
  alertType,
  sortBy,
  sortOrder,
}) => {
  const params =
    new URLSearchParams({
      status:
        status || '',

      userType:
        userType || '',

      alertType:
        alertType || '',

      sortBy:
        sortBy || 'createdAt',

      sortOrder:
        sortOrder || 'desc',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return apiClient.get(
    `/admin/sos-logs/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};

export default sosLogServices;
